import React from 'react'
import { useSelector } from 'react-redux'
import VideoBackground from './VideoBackground'
import VideoTitle from './VideoTitle'

const MainContainer = () => {
  const movies = useSelector((store) => store.movies?.nowPlayingMovies);
  if (movies === null) return

  const mainmovie = movies[0];
  const { original_title, overview, id } = mainmovie;

  return (
    <>
      <div className='pt-[40%] bg-black md:pt-0'>

      <VideoTitle title={original_title} overview={overview} />
      <VideoBackground movieID={id} />
      </div>
    </>
  )
}

export default MainContainer